import type { ReactNode } from 'react';
import { Topbar } from './Topbar.js';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Topbar />
      <main className="flex-1">
        <div className="mx-auto w-full max-w-[1400px] px-6 py-8">{children}</div>
      </main>
    </div>
  );
}
